<template>
  <input
    :type="type"
    :value="value"
    :placeholder="placeholder"
    class="input"
    autocomplete="off"
    v-on:input="$emit('input', $event.target.value)"
    @blur="$emit('blur', $event)"
  />
</template>

<script>
export default {
  props: ['value', 'placeholder', 'type'],
};
</script>

<style lang="less" scoped>
.input {
  border: none;
  font-size: 30px;
  padding: 6px 0;
  line-height: 34px;
  color: #3d424d;
  width: 100%;

  &::placeholder {
    color: #949aa4;
  }
}
</style>
